import MonitoAction from 'monito-action';
import {
    setVisitor,
    getVisitor
} from '@/util/auth';
import Fingerprint2 from 'fingerprintjs2';

let maInstance = null;
import {ip} from '@/api/system/h5'

const monitoAction = new MonitoAction();

monitoAction.init({
    frameType: 'h5',
    showLog: false,
    monitoSwitch: true,
    isPosition: false,
    userInfo: {
        userCode: "visitorId"
    },
    projectName: '权益',
    globaMonitoConfigList: []
})

async function createFingerprint() {
    return new Promise((resolve) => {
        if (!getVisitor()) {
            ip().then(res => {
                Fingerprint2.get((components) => {
                    let ip = res.msg
                    components.push({
                        key: 'ip',
                        value: ip
                    });
                    const values = components.map(component => component.value);
                    const visitorId = Fingerprint2.x64hash128(values.join(''), 31);
                    setVisitor(visitorId);
                    resolve(visitorId);
                });
            })
        } else {
            resolve(getVisitor());
        }
    });
}


export async function initMonito() {
    await new Promise(resolve => {
        if (window.requestIdleCallback) {
            requestIdleCallback(async () => {
                await createFingerprint().then(visitorId => {
                    resolve(visitorId);
                });
            });
        } else {
            setTimeout(async () => {
                await createFingerprint().then(visitorId => {
                    resolve(visitorId);
                });
            }, 500);
        }
    }).then(visitorId => {
        if (!monitoAction) {
            monitoAction.monitoInit.dataProcess.setUserInfo({
                userCode: visitorId,
                v_id: visitorId + '-' + Date.now()
            })
        }
    })
    return monitoAction;
}

export async function getMonitoAction() {
    if (!maInstance) {
        maInstance = await initMonito();
    }
    return maInstance;
}
